import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import NoKycCasinos from "./sections/NoKycCasinos";
import LearningPathways from "./sections/LearningPathways";
import EntertainmentVerticals from "./sections/EntertainmentVerticals";
import BisonFastFacts from "./sections/BisonFastFacts";
import DriverEmpowerment from "./sections/DriverEmpowerment";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <NoKycCasinos />
      <LearningPathways />
      <EntertainmentVerticals />
      <BisonFastFacts />
      <DriverEmpowerment />
      <Footer />
    </div>;
}